import { Tag } from 'antd';
import dayjs from 'dayjs';

export function getTagColor(expired, hasDeadline) {
  if (!hasDeadline) return <Tag color="blue">Бессрочный</Tag>;

  const now = new Date();
  const date = new Date(expired);
  const diffDays = Math.ceil((date - now) / (1000 * 60 * 60 * 24));

  const formattedDate = dayjs(date).format('DD.MM.YYYY');

  if (date < now) return <Tag color="red">{formattedDate}</Tag>;
  if (diffDays <= 7) return <Tag color="orange">{formattedDate}</Tag>;
  if (diffDays <= 30) return <Tag color="gold">{formattedDate}</Tag>;
  return <Tag color="green">{formattedDate}</Tag>;
}
